module.exports = __webpack_public_path__ + "static/media/icon-left.ec3c08fa.svg";